import React from "react";
import { RevealHeading, StaggerReveal } from "./Motion";
import { Headphones, EyeOff, Mug, UnderlineScribble, BnGlyph, Squiggle } from "./Decorations";

const ITEMS = [
    {
        icon: <Headphones color="#FF4FA3" className="w-16 h-16"/>,
        title: "Low engagement",
        body: "Average article session: 90 seconds. Audio listeners stay 7+ minutes — and finish what they started.",
        stat: "7×",
        statLabel: "longer dwell",
        color: "#FF4FA3",
    },
    {
        icon: <EyeOff color="#3D5BFF" className="w-16 h-16"/>,
        title: "Accessibility gap",
        body: "Millions of Bengali readers have low vision or limited literacy. Audio is the only door that opens.",
        stat: "12M+",
        statLabel: "underserved",
        color: "#3D5BFF",
    },
    {
        icon: <Mug color="#7B3FE4" className="w-16 h-16"/>,
        title: "No multitasking",
        body: "Reading needs eyes and hands. Audio frees them. Commute, cook, work out — your news goes everywhere.",
        stat: "3 of 4",
        statLabel: "want audio",
        color: "#7B3FE4",
    },
];

export const Problem = () => {
    return (
        <section className="relative py-24 lg:py-36 overflow-hidden">
            <BnGlyph glyph="পড়া" className="absolute -left-4 top-10 text-[180px] lg:text-[260px] leading-none font-bold opacity-[0.04] select-none" color="#0A0A0A"/>
            <Squiggle color="#FFD23F" className="absolute right-10 top-20 w-28 animate-float-slow"/>

            <div className="relative mx-auto max-w-[1240px] px-5 sm:px-8">
                <div className="max-w-[920px]">
                    <p className="text-[11px] uppercase tracking-[0.22em] font-semibold text-coral mb-5">The problem</p>
                    <RevealHeading
                        as="h2"
                        className="h-display text-[44px] sm:text-[64px] lg:text-[88px] text-ink"
                    >
                        Readers are leaving after 90 seconds. Audio keeps them for 7 minutes.
                    </RevealHeading>
                    <div className="mt-2 max-w-[280px]">
                        <UnderlineScribble color="#FF5B3E" className="w-full h-3"/>
                    </div>
                </div>

                <StaggerReveal className="mt-16 lg:mt-24 grid grid-cols-1 md:grid-cols-3 gap-5 lg:gap-7">
                    {ITEMS.map((it, i) => (
                        <article data-stagger key={i} data-testid={`problem-card-${i}`} className="bg-white rounded-3xl p-7 lg:p-8 border border-cream-300 shadow-soft hover:shadow-soft-lg transition-shadow group">
                            <div className="mb-6 inline-flex">
                                <div className="rounded-2xl p-3 bg-cream-100 group-hover:scale-105 transition-transform">
                                    {it.icon}
                                </div>
                            </div>
                            <h3 className="font-display text-[28px] lg:text-[32px] font-semibold tracking-tight text-ink mb-3">{it.title}</h3>
                            <p className="text-[15px] text-ink-muted leading-relaxed mb-6">{it.body}</p>
                            <div className="flex items-baseline gap-2 pt-5 border-t border-cream-300">
                                <span className="font-display font-bold text-[36px]" style={{ color: it.color }}>{it.stat}</span>
                                <span className="text-[12px] uppercase tracking-[0.18em] font-semibold text-ink-muted">{it.statLabel}</span>
                            </div>
                        </article>
                    ))}
                </StaggerReveal>
            </div>
        </section>
    );
};
